import { catchError, map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { IEffect } from '../../../../../../shared/modules/dynamic-effects/effect.interface';
import {
  JobsiteLoadAction,
  JobsiteLoadCompleteAction,
  JobsiteLoadFailAction,
  JobsiteSetAction,
  LoadJobsiteAddress,
  LoadJobsiteExperience,
  LS_LOAD,
  PurchaseOrderMaskPatterLoadAction,
  SalesAreaLoadAction,
} from '../../../actions/jobsite-actions/jobsite.actions';
import {
  IRequestJobsitesResponse,
  Jobsite,
} from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/jobsite.model';
import { IProductRequest } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/product.model';
import { ExperiencesRequest, JobsiteBlockedService } from '@cemex-core/cmx-api';
import { ModifyOrderState } from '@ordersnproducts/modules/new-modify-order/reducers';
import { FetchContacts } from '../../../actions/receiving-persons.action';
import { ProductLoadAction } from '../../../actions/products-actions/products.actions';
import { ACTION_TYPES, ORDER_ACTIONS } from '@ordersnproducts/modules/shared/constants/order-actions';
import { LoadHolidaysAction } from '@ordersnproducts/modules/order-builder/shared/modules/common-specification/actions/load-holidays.actions';
import { _safe } from '../../../../../../../modules/shared/utils/safe-get.method';

/**
 * An effect which monitors the actions$ Observable for (job-site) LOAD operations
 * and then
 */
@Injectable()
export class JobsiteLoadModifyWithMaskEffects implements IEffect {
  jobsiteLoadWithBlockedPurchaseOrderUL$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LS_LOAD),
      switchMap((action: JobsiteLoadAction) => {
        const selectedJobsiteId = action.payload.selectedJobsiteId;
        const productType = action.payload.jobsiteBlockedRequest.productTypeId;
        const productTypeCode = action.payload.jobsiteBlockedRequest.productTypeCode;
        const shippingConditionId = action.payload.shipingCondition.shippingConditionId;
        return this.blockedJobsiteLoaderService.getJobsites(action.payload.jobsiteBlockedRequest).pipe(
          map((response: any) => {
            response = response as IRequestJobsitesResponse;
            const selectedJobsite: Jobsite = response.jobsites.find((j) => j.jobsiteId === selectedJobsiteId);
            const productsRequest: IProductRequest = {
              jobsiteId: selectedJobsiteId,
              productTypeId: productType,
            };

            const experienceRequest: ExperiencesRequest = {
              actionType: ACTION_TYPES.ORDER,
              actionCode: ORDER_ACTIONS.MODIFY,
              jobsiteCode: selectedJobsite.jobsiteCode,
              jobsiteId: selectedJobsite.jobsiteId,
              productTypeCode: productTypeCode,
              countryCode: action.payload.legalEntity.countryCode,
            };

            this.store.dispatch(new LoadJobsiteAddress(selectedJobsite.address.addressId));
            this.store.dispatch(new LoadJobsiteExperience(experienceRequest));
            this.store.dispatch(new JobsiteSetAction(selectedJobsite));
            this.store.dispatch(new FetchContacts());
            this.store.dispatch(new ProductLoadAction(productsRequest));
            this.store.dispatch(
              new SalesAreaLoadAction({
                shipmentlocationId: selectedJobsite.jobsiteId,
                productlineId: productType,
                shippingConditionId: shippingConditionId,
              }),
            );
            this.store.dispatch(new LoadHolidaysAction({ countryCode: action.payload.legalEntity.countryCode }));
            this.store.dispatch(
              new PurchaseOrderMaskPatterLoadAction({ jobsiteId: selectedJobsiteId, productLine: productTypeCode }),
            );
            return new JobsiteLoadCompleteAction(response);
          }),
          catchError((error) => of(new JobsiteLoadFailAction(error))),
        );
      }),
    ),
  );

  /**
   *
   * @param {Store<ModifyOrderState>} store the usual in-memory store of application state.
   * @param {Actions} actions$ an Observable subclass which deals with actions
   *                           taken by or in the application
   * @param {ShipmentLocationsService} shipmentLocationService
   */
  constructor(
    private store: Store<ModifyOrderState>,
    private actions$: Actions,
    private blockedJobsiteLoaderService: JobsiteBlockedService,
  ) {}
}
